// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3CwsL","resendInfoText":"OnGoingPaymentBox_resendInfoText__32Y-p"};